import "./AllExperiences.css"
import Organizer from "./Organizer"
import Experience from "./Experience"
import { useEffect, useState } from 'react';

function AllExperiences() {
    const [original, setOriginal] = useState([]);
    const [displayed, setDisplayed] = useState([]);
    useEffect(() => {
        let experiences = require("./Resources/experiences.json");
        setOriginal(experiences.experiences);
        setDisplayed(experiences.experiences);
    }, []);

    function setItemsFunc(newArr) {
        setDisplayed(newArr);
    }


    let filters = [{"name": "A-Z", "var": "name"}, {"name": "Earliest", "var": "earliest"}, {"name": "Latest", "var": "latest"}]
return (
        <div className="AllExperiences">
        <h1>Experiences</h1>
        {/*organizer with name and earliest and latest filters*/}
        <Organizer filters={filters} setFunc={setItemsFunc} arr={original}/>
        {/*iterate over all experiences*/}
            {displayed.map((item) => (
                <Experience key={item.name} experience={item}/>
            ))}
        </div>

    );
}

export default AllExperiences;